<template>
	<popup class="v5-picker" v-model="state" :isLockScroll="false">
		<div class="v5-picker-panel" @click.stop>
			<div class="v5-picker-choose">
				<span class="cancel" @click="cancel">{{cancelTxt}}</span>
				<span class="confirm" @click="confirm">{{confirmTxt}}</span>
				<h1 class="v5-picker-title">{{title}}</h1>
			</div>
			<div class="v5-picker-content">
				<div class="mask-top border-bottom-skim"></div>
				<div class="mask-bottom border-top-skim"></div>
				<div class="wheel-wrapper" ref="wheelWrapper">
					<div class="wheel" v-for="(data, index) in pickerData" :key="index">
						<ul class="wheel-scroll">
							<li v-for="(item, n) in data" class="wheel-item" :key="n">{{item.text}}</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="v5-picker-footer"></div>
		</div>
	</popup>
</template>

<script>
/**
 * @desc picker 组件
 * @param {string} [data] - picker 数据
 * @param {string} [title] - picker 标题
 * @param {string} [cancelTxt] - 取消按钮
 * @param {string} [confirmTxt] - 确定按钮
 * @param {string} [selectedIndex] - 选中数据
 */
import Popup from './../popup';
import BScroll from '@better-scroll/core';
import Wheel from '@better-scroll/wheel';
BScroll.use(Wheel);

export default {
	name: 'v5-picker',
	props: {
		data: {
			type: Array,
			default() {
				return [];
			}
		},
		title: {
			type: String,
			default: ''
		},
		cancelTxt: {
			type: String,
			default: '取消'
		},
		confirmTxt: {
			type: String,
			default: '确定'
		},
		selectedIndex: {
			type: Array,
			default() {
				return [];
			}
		}
	},
	data() {
		return {
			state: false, // 展示标志
			pickerData: [...this.data], // picker 数据
			pickerSelectedIndex: this.selectedIndex, // 选中的 picker 索引
			pickerSelectedVal: [], // 选中的 value
			pickerSelectedText: [] // 选中的 text
		};
	},
	created() {
		if (!this.pickerSelectedIndex.length) {
			this.pickerSelectedIndex = new Array(this.pickerData.length).fill(0);
		}
	},
	watch: {
		data(newData) {
			this.setData(newData);
		}
	},
	methods: {
		/**
		 * picker 展示
		 */
		show() {
			if (this.state) return;
			this.state = true;
			if (!this.wheels || this.dirty) {
				this.$nextTick(() => {
					this.wheels = [];
					let wheelWrapper = this.$refs.wheelWrapper;
					for (let i = 0; i < this.pickerData.length; i++) {
						this._createWheel(wheelWrapper, i);
					}
					this.dirty = false;
				});
			} else {
				for (let i = 0; i < this.pickerData.length; i++) {
					this.wheels[i].enable();
					this.wheels[i].wheelTo(this.pickerSelectedIndex[i]);
				}
			}
		},
		/**
		 * picker 隐藏
		 */
		hide() {
			this.state = false;
			for (let i = 0; i < this.pickerData.length; i++) {
				this.wheels[i].disable();
			}
		},
		/**
		 * 确定
		 */
		confirm() {
			if (!this._canConfirm()) return;
			this.hide();
			let changed = false;
			for (let i = 0; i < this.pickerData.length; i++) {
				let index = this.wheels[i].getSelectedIndex();
				this.pickerSelectedIndex[i] = index;

				let value = null;
				if (this.pickerData[i].length) {
					value = this.pickerData[i][index].value;
				}
				if (this.pickerSelectedVal[i] !== value) {
					changed = true;
				}
				this.pickerSelectedVal[i] = this.pickerData[i][index].value; // liuj 加
				this.pickerSelectedText[i] = this.pickerData[i][index].text;
			}
			this.$emit('on-select', this.pickerSelectedVal, this.pickerSelectedIndex, this.pickerSelectedText);

			if (changed) {
				this.$emit('on-valuechange', this.pickerSelectedVal, this.pickerSelectedIndex, this.pickerSelectedText);
			}
		},
		/**
		 * 取消
		 */
		cancel() {
			this.hide();
			this.$emit('on-cancel');
		},
		/**
		 * 蒙层取消
		 */
		// maskCancel() {
		// 	this.hide();
		// 	this.$emit('on-maskCancel');
		// },
		setData(data) {
			this.pickerData = [...data];
			this.dirty = true;
		},
		scrollTo(index, dist) {
			const wheel = this.wheels[index];
			this.pickerSelectedIndex[index] = dist;
			wheel.wheelTo(dist);
		},
		refresh() {
			this.$nextTick(() => {
				this.wheels.forEach((wheel, index) => {
					wheel.refresh();
				});
			});
		},
		_createWheel(wheelWrapper, i) {
			if (!this.wheels[i]) {
				this.wheels[i] = new BScroll(wheelWrapper.children[i], {
					wheel: {
						selectedIndex: this.pickerSelectedIndex[i],
						/** 默认值就是下面配置的两个，为了展示二者的作用，这里再配置一下 */
						wheelWrapperClass: 'wheel-scroll',
						wheelItemClass: 'wheel-item'
					},
					probeType: 3
				});
				this.wheels[i].on('scrollEnd', () => {
					setTimeout(() => {
						this.$emit('on-change', i, this.wheels[i].getSelectedIndex());
					}, 0);
				});
			} else {
				this.wheels[i].refresh();
			}
			return this.wheels[i];
		},
		_canConfirm() {
			return this.wheels.every((wheel) => {
				return !wheel.isInTransition;
			});
		}
	},
	components: {
		Popup
	}
};
</script>

<style lang="scss">
@import './style.scss';
</style>
